/*
  Back button for /pages/categories subcategory pages (UAT-039).

  Adds an "All ..." back tile on "?sub=" and "?sub=&child=" pages under every
  main category. It always goes to that main category's page (no page
  history), from a subcategory or a type page alike:
    ?sub=X[&child=Y]  ->  ?main=<parent>   ("All Large Appliances")
  Names come from window.sgCatMenu (the Main Category menu data exposed by
  sections/subcategory-products.liquid).
*/
(function () {
  var BACK_CLASS = 'sg-back-btn';

  function themePath(path) {
    return typeof window.sgThemePath === 'function' ? window.sgThemePath(path) : path;
  }

  // Same singular/plural tolerance as resolveSubHandle() in the section
  // (menu links may say ?sub=chiller while the collection is "chillers").
  function sameHandle(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    var alt = b.slice(-1) === 's' ? b.slice(0, -1) : b + 's';
    return a === alt;
  }

  function findMenu(handle) {
    var menu = window.sgCatMenu || [];
    for (var i = 0; i < menu.length; i++) {
      if (sameHandle(menu[i].handle, handle)) return { main: menu[i] };
      var links = menu[i].links || [];
      for (var j = 0; j < links.length; j++) {
        if (sameHandle(links[j].handle, handle)) return { main: menu[i], sub: links[j] };
      }
    }
    return null;
  }

  // Always back to the main category page (?main=), from a subcategory
  // or a type page alike.
  function levelUpTarget() {
    var found = findMenu(new URLSearchParams(window.location.search).get('sub'));
    if (!found || !found.main) return { url: null, label: 'Previous Page' };
    return { url: themePath('/pages/categories?main=' + encodeURIComponent(found.main.handle)), label: found.main.title };
  }

  // Always exactly one level up (no page history).
  function getBackTarget() {
    return levelUpTarget();
  }

  // Shown under every main category whose subcategory is found in the menu.
  function backAllowed() {
    var found = findMenu(new URLSearchParams(window.location.search).get('sub'));
    return !!(found && found.main);
  }

  // Back tile: same size as the subcategory tiles, placed FIRST in the tile
  // row with a thin divider after it, so it sits with the levels it moves
  // between (white card, blue chevron circle, "All Refrigerators" label).
  // It's sticky at the row's left edge: on rows that scroll sideways (phones,
  // Small Appliances' 13 tiles) the other tiles slide behind it while it
  // stays put. A 20px white shadow covers the gap so tiles pass under
  // cleanly, and the divider is drawn by the card itself so it stays too.
  function backText(name) {
    return name ? 'All ' + name : 'Back';
  }

  function createBackButton() {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = BACK_CLASS;
    card.innerHTML =
      '<span class="sg-back-btn__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M14.5 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="sg-back-btn__label"></span>';

    card.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var target = getBackTarget();
      if (target.url) {
        window.location.href = target.url;
      } else {
        window.history.back();
      }
    });
    return card;
  }

  function updateLabel(card) {
    var text = backText(getBackTarget().label);
    card.querySelector('.sg-back-btn__label').textContent = text;
    card.setAttribute('aria-label', text);
  }

  // On phones/tablets the row is a 2-row CSS grid, and a sticky grid item
  // can't leave its own grid cell, so it would scroll away. There the back
  // tile goes OUTSIDE the scrolling row instead, in a small flex wrapper
  // [back tile | row], so it simply never scrolls. On desktop the row is a
  // flex line, where the sticky back tile inside the row works.
  var WRAP_CLASS = 'sg-back-wrap';

  function useWrapper(list) {
    return getComputedStyle(list).display === 'grid';
  }

  function unwrap(list) {
    var wrap = list.parentElement;
    if (!wrap || !wrap.classList.contains(WRAP_CLASS)) return;
    wrap.parentElement.insertBefore(list, wrap);
    wrap.remove();
  }

  function ensureBackButton(list) {
    var hasSub = new URLSearchParams(window.location.search).get('sub') && backAllowed();
    var wrap = list.parentElement.classList.contains(WRAP_CLASS) ? list.parentElement : null;
    var card = (wrap || list).querySelector('.' + BACK_CLASS);
    var tiles = list.querySelectorAll('.subcategory-card');

    if (!hasSub || !tiles.length) {
      if (card) card.remove();
      unwrap(list);
      return;
    }
    if (!card) card = createBackButton();

    if (useWrapper(list)) {
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = WRAP_CLASS;
        list.parentElement.insertBefore(wrap, list);
        wrap.appendChild(list);
      }
      if (wrap.firstElementChild !== card) wrap.insertBefore(card, list);
      // Original tile width = a third of the full row, minus the grid gaps.
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var orig = (wrap.getBoundingClientRect().width - 2 * gap) / 3;
      if (orig > 0) wrap.style.setProperty('--sg-tile-orig', orig + 'px');
    } else {
      unwrap(list);
      if (list.firstElementChild !== card) list.insertBefore(card, list.firstElementChild);
    }

    var oldDivider = list.querySelector('.sg-back-divider');
    if (oldDivider) oldDivider.remove();
    updateLabel(card);
  }

  function addStyles() {
    if (document.getElementById('sg-back-btn-styles')) return;
    var style = document.createElement('style');
    style.id = 'sg-back-btn-styles';
    style.textContent = [
      '.' + BACK_CLASS + '{',
      '  position:sticky;left:0;z-index:3;margin-right:10px !important;box-shadow:20px 0 0 #fff;',
      '  flex:0 0 auto;align-self:stretch;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;',
      '  box-sizing:border-box;width:var(--sg-tile-w,140px);margin:0;padding:10px 8px;',
      '  background:#fff;border:1px solid #e3e5ef;border-radius:2px;color:#2D348A;',
      '  font-family:Montserrat,sans-serif;cursor:pointer;transition:background .2s,color .2s,border-color .2s,box-shadow .2s;',
      '}',
      '.' + BACK_CLASS + ' .sg-back-btn__icon{',
      '  display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;flex:0 0 auto;',
      '  border-radius:50%;background:#2D348A;color:#fff;transition:transform .2s,background .2s,color .2s;',
      '}',
      '.' + BACK_CLASS + ' .sg-back-btn__label{font-size:13px;font-weight:600;line-height:1.25;text-align:center}',
      '.' + BACK_CLASS + ':hover{background:#2D348A;color:#fff;border-color:#2D348A;box-shadow:20px 0 0 #fff,0 2px 10px rgba(45,52,138,.25)}',
      '.' + BACK_CLASS + ':hover .sg-back-btn__icon{background:#fff;color:#2D348A;transform:translateX(-2px)}',
      '.' + BACK_CLASS + ':focus-visible{outline:2px solid #2D348A;outline-offset:2px}',
      '.' + BACK_CLASS + '::after{content:"";position:absolute;top:15%;right:-11px;width:1px;height:70%;background:#d9dbe6;pointer-events:none}',
      // sg-mobile-figma.css hides every non-tile child of the row at
      // <=991px (".subcategory-list > :not(.subcategory-card)"); out-specify
      // it. On phones the row is a 2-row grid scrolling sideways, so the
      // back tile spans both rows as a sticky column on the left.
      '@media (max-width:991px){',
      '  html body .subcategory-products-section .subcategory-list > .' + BACK_CLASS + '.' + BACK_CLASS + '{display:flex !important}',
      '  .' + BACK_CLASS + ' .sg-back-btn__label{font-size:12px}',
      '}',
      // Phone/tablet wrapper: back tile (fixed) + the scrolling grid row.
      '.' + WRAP_CLASS + '{display:flex;align-items:stretch;gap:10px;width:100%;min-width:0}',
      '.' + WRAP_CLASS + ' > .subcategory-list{flex:1 1 auto;min-width:0}',
      // Keep the tiles their original phone size (a third of the full row)
      // instead of shrinking into the narrower row next to the back tile.
      'html body .subcategory-products-section .' + WRAP_CLASS + ' > .subcategory-list.subcategory-list{grid-auto-columns:var(--sg-tile-orig) !important}',
      '.' + WRAP_CLASS + ' > .' + BACK_CLASS + '{position:relative;left:auto;margin-right:0 !important;box-shadow:none;width:var(--sg-tile-w,90px)}',
      '.' + WRAP_CLASS + ' > .' + BACK_CLASS + '::after{right:-6px}',
      // Slider dots (see updateDots).
      '.subcategory-mobile-dots.sg-dots-replaced{display:none !important}',
      '.sg-back-dots{display:flex;justify-content:center;align-items:center;gap:8px;margin:12px 0 0;width:100%;grid-column:1 / -1}',
      '.sg-back-dot{display:block;width:8px;height:8px;padding:0;border:0;border-radius:50%;background:#d9dbe6;cursor:pointer;transition:background .2s,transform .2s}',
      '.sg-back-dot.is-active{background:#2D348A;transform:scale(1.15)}',
      '.sg-back-dot:focus-visible{outline:2px solid #2D348A;outline-offset:2px}',
      // One line of tiles (the row is already a sideways slider): override
      // sg-mobile-figma.css's 2-row grid (repeat(2, 90px)) when the back
      // tile is present, and fit the back tile into that single 90px row.
      'html body .subcategory-products-section .subcategory-scroller-container .' + WRAP_CLASS + ' > .subcategory-list.subcategory-list{grid-template-rows:90px !important;grid-auto-flow:column !important}',
      // The section's phone script pins each tile to a 3x2 page slot with an
      // inline grid-area; release that so tiles just follow in one line.
      'html body .subcategory-products-section .' + WRAP_CLASS + ' > .subcategory-list > .subcategory-card{grid-area:auto !important}',
      '.' + WRAP_CLASS + ' > .' + BACK_CLASS + '{height:90px;padding:6px 4px;gap:4px}',
      '.' + WRAP_CLASS + ' > .' + BACK_CLASS + ' .sg-back-btn__icon{width:28px;height:28px}',
      '.' + WRAP_CLASS + ' > .' + BACK_CLASS + ' .sg-back-btn__label{font-size:11px;line-height:1.2}',
      '@media (prefers-reduced-motion:reduce){.' + BACK_CLASS + ',.' + BACK_CLASS + ' .sg-back-btn__icon{transition:none}}'
    ].join('');
    document.head.appendChild(style);
  }

  // Match the back tile's width to the real tiles (they size differently on
  // desktop, iPad and phones).
  function syncTileWidth(list) {
    var tile = list.querySelector('.subcategory-card');
    var card = (list.parentElement.classList.contains(WRAP_CLASS) ? list.parentElement : list).querySelector('.' + BACK_CLASS);
    if (tile && card) card.style.setProperty('--sg-tile-w', tile.getBoundingClientRect().width + 'px');
    // When the back tile sticks inside the row it covers the row's left
    // edge; tell scrolling/snapping so tiles land after it, not under it.
    var inRow = card && card.parentElement === list;
    list.style.scrollPaddingLeft = inRow ? (card.getBoundingClientRect().width + 10) + 'px' : '';
  }

  // On load the section scrolls the selected tile to the CENTER of the row
  // (smoothly), which on narrow screens pushes the first tile under the
  // sticky back tile. Once that's settled: if the selected tile is visible
  // with the row at its start, go back to the start (first tile fully
  // visible); otherwise put the selected tile just after the back tile.
  function settleInitialScroll(list) {
    var wrapped = list.parentElement.classList.contains(WRAP_CLASS);
    var card = (wrapped ? list.parentElement : list).querySelector('.' + BACK_CLASS);
    if (!card || list.scrollWidth <= list.clientWidth + 1) return;
    // In the row (sticky) the back tile covers the row's left edge; in the
    // phone wrapper it sits outside the row and covers nothing.
    var cover = wrapped ? 0 : card.getBoundingClientRect().width + 10;
    var active = list.querySelector('.subcategory-card.active');
    var target = 0;
    if (active) {
      var r = active.getBoundingClientRect();
      var leftAtStart = r.left - list.getBoundingClientRect().left + list.scrollLeft;
      // Only move off the start if the selected tile would be entirely
      // out of view there; a tile that's just clipped stays put.
      if (leftAtStart > list.clientWidth - 24) target = leftAtStart - cover;
    }
    list.scrollTo({ left: Math.max(0, target), behavior: 'instant' });
  }

  // Slider dots under the tile row whenever it scrolls sideways (phones and
  // desktop), so it's clear it's a slider. One dot per screen-width of tiles
  // (the section's own dots count 6 tiles a page, which no longer matches
  // the one-line row), active dot follows the scroll, tapping a dot scrolls
  // there. While shown, the section's own dots are hidden.
  var DOTS_CLASS = 'sg-back-dots';

  function getDotPages(list) {
    var max = list.scrollWidth - list.clientWidth;
    if (max <= 1) return null;
    var card = list.querySelector('.' + BACK_CLASS);
    var view = list.clientWidth - (card ? card.getBoundingClientRect().width + 10 : 0);
    return { max: max, count: 1 + Math.ceil(max / Math.max(view, 1)) };
  }

  function updateDots(list) {
    var row = list.parentElement.classList.contains(WRAP_CLASS) ? list.parentElement : list;
    var host = row.parentElement;
    var dots = host.querySelector(':scope > .' + DOTS_CLASS);
    var sectionDots = host.querySelector(':scope > .subcategory-mobile-dots');
    var hasBack = !!host.querySelector('.' + BACK_CLASS);
    // Dots only when there are more than 3 cards in total (back tile
    // included) - up to 3 fit on one screen, so a slider hint isn't needed.
    var cardCount = list.querySelectorAll('.subcategory-card').length + (hasBack ? 1 : 0);
    var pages = hasBack && cardCount > 3 ? getDotPages(list) : null;

    if (!pages) {
      if (dots) dots.remove();
      // Only toggle our class: the section shows its own dots with an inline
      // display:flex, which must be left alone.
      if (sectionDots) sectionDots.classList.remove('sg-dots-replaced');
      return;
    }
    if (sectionDots) sectionDots.classList.add('sg-dots-replaced');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = DOTS_CLASS;
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Subcategory slider');
    }
    // Last in the row's container, full width: on desktop that container is
    // a grid (prev arrow / tiles / next arrow), so this gives the dots their
    // own line below without displacing the arrows.
    if (host.lastElementChild !== dots) host.appendChild(dots);

    if (dots.children.length !== pages.count) {
      dots.innerHTML = '';
      for (var i = 0; i < pages.count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sg-back-dot';
        dot.setAttribute('aria-label', 'Show subcategories, part ' + (i + 1) + ' of ' + pages.count);
        dot.dataset.page = i;
        dot.addEventListener('click', function (event) {
          var p = getDotPages(list);
          if (!p) return;
          var page = Number(event.currentTarget.dataset.page);
          list.scrollTo({ left: p.max * page / (p.count - 1), behavior: 'smooth' });
        });
        dots.appendChild(dot);
      }
    }
    var active = Math.round(list.scrollLeft / pages.max * (pages.count - 1));
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  }

  function init() {
    addStyles();
    var section = document.querySelector('.subcategory-products-section') || document;
    var list = section.querySelector('.subcategory-list');
    if (!list) return;

    var refresh = function () {
      ensureBackButton(list);
      syncTileWidth(list);
      updateDots(list);
      // Tiles finish sizing after layout/images, so match again once settled.
      requestAnimationFrame(function () { syncTileWidth(list); updateDots(list); });
      setTimeout(function () { syncTileWidth(list); updateDots(list); }, 400);
    };
    list.addEventListener('scroll', function () { updateDots(list); }, { passive: true });
    refresh();
    new MutationObserver(refresh).observe(list, { childList: true });

    // After the section's own load-time "scroll selected tile to center"
    // (runs ~50ms after load, smooth) has finished.
    setTimeout(function () { settleInitialScroll(list); }, 900);
    setTimeout(function () { settleInitialScroll(list); }, 1800);

    // Picking a type tile updates the URL with pushState (no reload, no
    // list rebuild), so refresh the label on clicks and history moves too.
    list.addEventListener('click', function () { setTimeout(refresh, 0); });
    window.addEventListener('popstate', refresh);
    window.addEventListener('load', refresh);
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
